import styled from 'styled-components';

export const PaginationFooterStyled = styled.div<{
  showButtons: boolean;
  paginationPadding?: string;
}>`
  ${(props) =>
    props.showButtons
      ? `display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 20px 0 20px;
        margin-bottom: 20px;
        border-top: solid 1px ${props.theme.atlas.semantic.color.outline.default};
        div {
          padding: 0;
        }`
      : `padding-top: 20px; ${
          props.paginationPadding && `padding: ${props.paginationPadding};`
        }`}
`;
